export default __webpack_public_path__ + "upload/loader.0285118e.gif";